import Menu from 'Models/Menu';

export default [
  Menu.recordCreate,
  Menu.directoryCreate,
  // Menu.assetInformation,
  Menu.assetMaterialEdit,
  Menu.assetMaterialDelete,
  Menu.searchAsset,
  // Menu.assetAlert,
  Menu.assetsHelp,
];
